<mat-dialog-content>
    <h4>{{msg}}</h4>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-flat-button color="primary" mat-dialog-close cdkFocusInitial (click)="ok()">{{buttonLabel}}</button>
  </mat-dialog-actions>